import React, { Component, useEffect, useState } from "react";
// Style
import './BlogSideBar.css';
// services
import { BlogsHome } from "../../Service/data";
import { getCategories } from "../../Service/data";
import { searchBlogs } from "../../Service/data";




export const BlogSide = () => {

    const [ cate , setCate ] = useState([""]);
    const [ blogs , setBlogs ] = useState([""]);


    useEffect(()=>{
        BlogsHome().then((data)=>{
            setBlogs(data);
        }).finally(()=>{
            setTimeout(() => {
                titlesLength();
            }, 10);
        });

        getCategories().then((data)=>{
            setCate(data);
        });
    },[]);





    const getSearchedBlogs = (event) =>{
        let value = event.target.value;
        if (value.length > 0) {
            if (event.key == "Enter") {
                if ( window.location.pathname == "/blog") {
                    window.location.href = "/Blogs?search=" + value;
                }else{
                    window.location.replace("/Blogs?search=" + value);
                }
            }
        }
    }







/*
    window.addEventListener("DOMContentLoaded" , ()=>{
        let SearchIconBtn = document.getElementById("SearchIconBtn");

        SearchIconBtn.addEventListener("click" , ()=>{
            let value = document.getElementById("searchInput").value;
        });

        SearchIconBtn.addEventListener("submit" , ()=>{
            let value = document.getElementById("searchInput").value;
        });
    });

*/


    const titlesLength = () =>{
        let RecentBlogTitle = document.querySelectorAll(".RecentBlogTitle");

        for (let i = 0; i < RecentBlogTitle.length; i++) {
            let length = RecentBlogTitle[i].innerHTML.length;
            let word = RecentBlogTitle[i].innerHTML;
            if (length > 45) {
                let text = word.substring(0 , 44);  
                RecentBlogTitle[i].innerHTML = text + "...";
            }
        }
    }


    return(
        <div className="BodyBlogSideBar" >
                <div className="SearchBoxContainer d-flex justify-content-end align-items-center">  
                    <div className="searchBox d-flex justify-content-between align-items-center">
                        <input type="text" placeholder="Suche" id="searchInput" onKeyPress={getSearchedBlogs}  className="searchBoxInput"/> <div id="SearchIconBtn"> <i class="fas fa-search SearchIcon" id="SearchIcon"></i> </div>
                    </div>
                </div>

                <div className="CateMainContainer">
                    
                    <p className="CateMainTitle">Categories</p>
                    <ul className="ulCateSBar">
                        { cate.map( cate => <a href={"/Blogs?c=" + cate.name} ><li className="CateItemSBar d-flex justify-content-between align-items-center"><span>{cate.name}</span> <span className="CateNumSBar">({cate.number})</span></li></a>  )} 
                    </ul>
                    <a href="/Blogs?c=all"> <div className="SeeAllButton d-flex justify-content-center align-items-center">Alle Blogs zeigen</div> </a>
                </div>

                <div className="CateMainContainer">
                    <p className="CateMainTitle">Recent Blog</p>


                    { blogs.map( Blog => 

                        <div className="RecentBlogCard d-flex justify-content-between align-items-top ">
                            <div className="RecentBlogImageContainer">
                                <a href={"?id=" + Blog.id} ><img className="RecentBlogImage" src={Blog.BlogImage} /></a>
                            </div>
                            <div className="dsattgv d-flex flex-column justify-content-center">
                                <a href={"/blog?id=" + Blog.id} ><p className="RecentBlogTitle">{Blog.BlogTitle}</p></a>
                                <div className=" d-flex flex-warp">
                                    <div className="IconContainerREBlo"><i className="fas fa-clock IconBlogReBlog"></i> <span className="LableIconReBlog">{Blog.date}</span></div>
                                    <div className="IconContainerREBlo"><i className="fas fa-user IconBlogReBlog"></i> <span className="LableIconReBlog">{Blog.author}</span></div>
                                    <div className="IconContainerREBlo"><i className="fas fa-comment-dots IconBlogReBlog"></i> <span className="LableIconReBlog">{Blog.CommentsNumber}</span></div>
                                </div>
                            </div>
                        </div>
                    )}
                   
                </div>


            </div>
    )
} 